/* tslint:disable */
/* eslint-disable */
/**
 * TrashBinManage API
 * ゴミ箱関連の操作
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * 集計情報
 * @export
 * @interface AggregateBusiness
 */
export interface AggregateBusiness {
    /**
     * 集計ID
     * @type {string}
     * @memberof AggregateBusiness
     */
    'aggregateBusinessId'?: string;
    /**
     * 置き場CD
     * @type {string}
     * @memberof AggregateBusiness
     */
    'warehouseNumber'?: string;
    /**
     * 置き場名
     * @type {string}
     * @memberof AggregateBusiness
     */
    'warehouse'?: string;
    /**
     * 仕入先CD
     * @type {string}
     * @memberof AggregateBusiness
     */
    'supplierNumber'?: string;
    /**
     * 仕入先名
     * @type {string}
     * @memberof AggregateBusiness
     */
    'supplierName'?: string;
    /**
     * 商品CD
     * @type {string}
     * @memberof AggregateBusiness
     */
    'businessNumber'?: string;
    /**
     * 商品名
     * @type {string}
     * @memberof AggregateBusiness
     */
    'businessName'?: string;
    /**
     * 容量
     * @type {number}
     * @memberof AggregateBusiness
     */
    'package'?: number;
    /**
     * 在庫年月日
     * @type {number}
     * @memberof AggregateBusiness
     */
    'executionDate'?: number;
    /**
     * 最終更新日
     * @type {number}
     * @memberof AggregateBusiness
     */
    'updateAt'?: number;
    /**
     * 単位
     * @type {string}
     * @memberof AggregateBusiness
     */
    'unit'?: string;
    /**
     * 製造社
     * @type {string}
     * @memberof AggregateBusiness
     */
    'manufacturer'?: string;
    /**
     * 標準在庫指数（MIN）
     * @type {number}
     * @memberof AggregateBusiness
     */
    'standardInventoryIndexMin'?: number;
    /**
     * 標準在庫指数（MAX）
     * @type {number}
     * @memberof AggregateBusiness
     */
    'standardInventoryIndexMax'?: number;
    /**
     * 標準在庫指数（単位）
     * @type {string}
     * @memberof AggregateBusiness
     */
    'standardInventoryIndexUnit'?: string;
    /**
     * リードタイム
     * @type {number}
     * @memberof AggregateBusiness
     */
    'leadTime'?: number;
    /**
     * リードタイム単位
     * @type {string}
     * @memberof AggregateBusiness
     */
    'leadTimeUnit'?: string;
    /**
     * MQQ
     * @type {number}
     * @memberof AggregateBusiness
     */
    'moq'?: number;
    /**
     * ユーザーデータの配列
     * @type {Array<UserData>}
     * @memberof AggregateBusiness
     */
    'aggregateBusinessResponsibleUsers'?: Array<UserData>;
    /**
     * 入荷情報
     * @type {Array<Arrival>}
     * @memberof AggregateBusiness
     */
    'arrivals'?: Array<Arrival>;
    /**
     * 在庫情報
     * @type {Array<Inventory>}
     * @memberof AggregateBusiness
     */
    'inventories'?: Array<Inventory>;
    /**
     * 販売実績
     * @type {Array<SalesResult>}
     * @memberof AggregateBusiness
     */
    'salesResults'?: Array<SalesResult>;
    /**
     * 客先内示情報
     * @type {Array<CustomerAnnounce>}
     * @memberof AggregateBusiness
     */
    'customerAnnounces'?: Array<CustomerAnnounce>;
}
/**
 * 取引情報
 * @export
 * @interface AggregateBusinessIncludedBusiness
 */
export interface AggregateBusinessIncludedBusiness {
    /**
     * 取引ID
     * @type {string}
     * @memberof AggregateBusinessIncludedBusiness
     */
    'businessId'?: string;
    /**
     * 売上先CD
     * @type {string}
     * @memberof AggregateBusinessIncludedBusiness
     */
    'customerNumber'?: string;
    /**
     * 売上先名
     * @type {string}
     * @memberof AggregateBusinessIncludedBusiness
     */
    'customerName'?: string;
    /**
     * 送り先CD
     * @type {string}
     * @memberof AggregateBusinessIncludedBusiness
     */
    'salesDestinationNumber'?: string;
    /**
     * 送り先名
     * @type {string}
     * @memberof AggregateBusinessIncludedBusiness
     */
    'salesDestinationName'?: string;
    /**
     * エンドユーザー
     * @type {string}
     * @memberof AggregateBusinessIncludedBusiness
     */
    'endUser'?: string;
    /**
     * 最終更新日
     * @type {number}
     * @memberof AggregateBusinessIncludedBusiness
     */
    'updateAt'?: number;
    /**
     * ユーザーデータの配列
     * @type {Array<UserData>}
     * @memberof AggregateBusinessIncludedBusiness
     */
    'baseBusinessResponsibleUsers'?: Array<UserData>;
    /**
     * 販売実績
     * @type {Array<SalesResult>}
     * @memberof AggregateBusinessIncludedBusiness
     */
    'salesResults'?: Array<SalesResult>;
    /**
     * 客先内示情報
     * @type {Array<CustomerAnnounce>}
     * @memberof AggregateBusinessIncludedBusiness
     */
    'customerAnnounces'?: Array<CustomerAnnounce>;
}
/**
 * 入荷情報
 * @export
 * @interface Arrival
 */
export interface Arrival {
    /**
     * 集計ID
     * @type {string}
     * @memberof Arrival
     */
    'aggregateBusinessId'?: string;
    /**
     * 入荷ID
     * @type {string}
     * @memberof Arrival
     */
    'arrivalId'?: string;
    /**
     * 入荷年
     * @type {number}
     * @memberof Arrival
     */
    'targetYear'?: number;
    /**
     * 入荷月
     * @type {number}
     * @memberof Arrival
     */
    'targetMonth'?: number;
    /**
     * 入荷数量
     * @type {number}
     * @memberof Arrival
     */
    'arrivalAmount'?: number;
}
/**
 * 取引情報
 * @export
 * @interface Business
 */
export interface Business {
    /**
     * 
     * @type {string}
     * @memberof Business
     */
    'organizationId'?: string;
    /**
     * 取引ID
     * @type {string}
     * @memberof Business
     */
    'businessId'?: string;
    /**
     * 置き場CD
     * @type {string}
     * @memberof Business
     */
    'warehouseNumber'?: string;
    /**
     * 置き場名
     * @type {string}
     * @memberof Business
     */
    'warehouse'?: string;
    /**
     * 仕入先CD
     * @type {string}
     * @memberof Business
     */
    'supplierNumber'?: string;
    /**
     * 仕入先名
     * @type {string}
     * @memberof Business
     */
    'supplierName'?: string;
    /**
     * 商品CD
     * @type {string}
     * @memberof Business
     */
    'businessNumber'?: string;
    /**
     * 商品名
     * @type {string}
     * @memberof Business
     */
    'businessName'?: string;
    /**
     * 容量
     * @type {number}
     * @memberof Business
     */
    'package'?: number;
    /**
     * 単位
     * @type {string}
     * @memberof Business
     */
    'unit'?: string;
    /**
     * 製造社
     * @type {string}
     * @memberof Business
     */
    'manufacturer'?: string;
    /**
     * 在庫年月日
     * @type {number}
     * @memberof Business
     */
    'executionDate'?: number;
    /**
     * ユーザーデータの配列
     * @type {Array<UserData>}
     * @memberof Business
     */
    'aggregateBusinessResponsibleUsers'?: Array<UserData>;
    /**
     * 最終更新日
     * @type {number}
     * @memberof Business
     */
    'updateAt'?: number;
    /**
     * 売上先CD
     * @type {string}
     * @memberof Business
     */
    'customerNumber'?: string;
    /**
     * 売上先名
     * @type {string}
     * @memberof Business
     */
    'customerName'?: string;
    /**
     * 送り先CD
     * @type {string}
     * @memberof Business
     */
    'salesDestinationNumber'?: string;
    /**
     * 送り先名
     * @type {string}
     * @memberof Business
     */
    'salesDestinationName'?: string;
    /**
     * エンドユーザー
     * @type {string}
     * @memberof Business
     */
    'endUser'?: string;
    /**
     * ユーザーデータの配列
     * @type {Array<UserData>}
     * @memberof Business
     */
    'baseBusinessResponsibleUsers'?: Array<UserData>;
    /**
     * 販売実績
     * @type {Array<SalesResult>}
     * @memberof Business
     */
    'salesResults'?: Array<SalesResult>;
    /**
     * 客先内示情報
     * @type {Array<CustomerAnnounce>}
     * @memberof Business
     */
    'customerAnnounces'?: Array<CustomerAnnounce>;
}
/**
 * 現在の年月
 * @export
 * @interface CurrentYearMonth
 */
export interface CurrentYearMonth {
    /**
     * 現在の年
     * @type {number}
     * @memberof CurrentYearMonth
     */
    'currentYear'?: number;
    /**
     * 現在の月
     * @type {number}
     * @memberof CurrentYearMonth
     */
    'currentMonth'?: number;
}
/**
 * 客先内示情報
 * @export
 * @interface CustomerAnnounce
 */
export interface CustomerAnnounce {
    /**
     * 集計/関連取引ID
     * @type {string}
     * @memberof CustomerAnnounce
     */
    'businessId'?: string;
    /**
     * 客先内示受領年
     * @type {number}
     * @memberof CustomerAnnounce
     */
    'customerForecastReceivedYear'?: number;
    /**
     * 客先内示受領月
     * @type {number}
     * @memberof CustomerAnnounce
     */
    'customerForecastReceivedMonth'?: number;
    /**
     * 客先内示対象年
     * @type {number}
     * @memberof CustomerAnnounce
     */
    'customerForecastTargetYear'?: number;
    /**
     * 客先内示対象月
     * @type {number}
     * @memberof CustomerAnnounce
     */
    'customerForecastTargetMonth'?: number;
    /**
     * 客先内示数量
     * @type {number}
     * @memberof CustomerAnnounce
     */
    'customerForecastAmount'?: number;
}
/**
 * 
 * @export
 * @interface DeleteTrashBinAggregateBusinessRequest
 */
export interface DeleteTrashBinAggregateBusinessRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof DeleteTrashBinAggregateBusinessRequest
     */
    'deleteTrashBinAggregateBusinessIdArray'?: Array<string>;
}
/**
 * ゴミ箱内集計情報の完全削除APIのレスポンスで返ってくるデータの型\"
 * @export
 * @interface DeleteTrashBinAggregateBusinessSuccessResponseInfo
 */
export interface DeleteTrashBinAggregateBusinessSuccessResponseInfo {
    /**
     * 
     * @type {number}
     * @memberof DeleteTrashBinAggregateBusinessSuccessResponseInfo
     */
    'statusCode': number;
    /**
     * 
     * @type {number}
     * @memberof DeleteTrashBinAggregateBusinessSuccessResponseInfo
     */
    'code': number;
    /**
     * 
     * @type {string}
     * @memberof DeleteTrashBinAggregateBusinessSuccessResponseInfo
     */
    'message': string;
    /**
     * 
     * @type {UpdateTrashBinAggregateBusinessSuccessResponseInfoAllOfResult}
     * @memberof DeleteTrashBinAggregateBusinessSuccessResponseInfo
     */
    'result': UpdateTrashBinAggregateBusinessSuccessResponseInfoAllOfResult;
}
/**
 * 
 * @export
 * @interface DeleteTrashBinBusinessRequest
 */
export interface DeleteTrashBinBusinessRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof DeleteTrashBinBusinessRequest
     */
    'deleteTrashBinBusinessIdArray'?: Array<string>;
}
/**
 * ゴミ箱内取引情報の完全削除APIのレスポンスで返ってくるデータの型\"
 * @export
 * @interface DeleteTrashBinBusinessSuccessResponseInfo
 */
export interface DeleteTrashBinBusinessSuccessResponseInfo {
    /**
     * 
     * @type {number}
     * @memberof DeleteTrashBinBusinessSuccessResponseInfo
     */
    'statusCode': number;
    /**
     * 
     * @type {number}
     * @memberof DeleteTrashBinBusinessSuccessResponseInfo
     */
    'code': number;
    /**
     * 
     * @type {string}
     * @memberof DeleteTrashBinBusinessSuccessResponseInfo
     */
    'message': string;
    /**
     * 
     * @type {UpdateTrashBinAggregateBusinessSuccessResponseInfoAllOfResult}
     * @memberof DeleteTrashBinBusinessSuccessResponseInfo
     */
    'result': UpdateTrashBinAggregateBusinessSuccessResponseInfoAllOfResult;
}
/**
 * エラーレスポンス
 * @export
 * @interface ErrorResponse
 */
export interface ErrorResponse {
    /**
     * 
     * @type {number}
     * @memberof ErrorResponse
     */
    'statusCode': number;
    /**
     * 
     * @type {string}
     * @memberof ErrorResponse
     */
    'headers': string;
    /**
     * 
     * @type {ErrorResponseBody}
     * @memberof ErrorResponse
     */
    'body': ErrorResponseBody;
}
/**
 * 
 * @export
 * @interface ErrorResponseBody
 */
export interface ErrorResponseBody {
    /**
     * 
     * @type {number}
     * @memberof ErrorResponseBody
     */
    'statusCode': number;
    /**
     * 
     * @type {ErrorResponseCode}
     * @memberof ErrorResponseBody
     */
    'code': ErrorResponseCode;
    /**
     * 
     * @type {string}
     * @memberof ErrorResponseBody
     */
    'message': string;
}


/**
 * エラー時のレスポンスコード backendのcommon_layer/return_code.py参照
 * @export
 * @enum {string}
 */

export const ErrorResponseCode = {
    BadRequest: 'BAD_REQUEST',
    NotRegisteredBusiness: 'NOT_REGISTERED_BUSINESS',
    FkConstraintFailed: 'FK_CONSTRAINT_FAILED',
    Unauthorized: 'UNAUTHORIZED',
    Forbidden: 'FORBIDDEN',
    NotFound: 'NOT_FOUND',
    ResourceConflict: 'RESOURCE_CONFLICT',
    UpdateTimingConflict: 'UPDATE_TIMING_CONFLICT',
    InternalServerError: 'INTERNAL_SERVER_ERROR'
} as const;

export type ErrorResponseCode = typeof ErrorResponseCode[keyof typeof ErrorResponseCode];


/**
 * ゴミ箱内の集計情報の関連取引取得APIのレスポンスで返ってくるデータの型\"
 * @export
 * @interface GetTrashBinAggregateBusinessIncludedBusinessSuccessResponseInfo
 */
export interface GetTrashBinAggregateBusinessIncludedBusinessSuccessResponseInfo {
    /**
     * 
     * @type {number}
     * @memberof GetTrashBinAggregateBusinessIncludedBusinessSuccessResponseInfo
     */
    'statusCode': number;
    /**
     * 
     * @type {number}
     * @memberof GetTrashBinAggregateBusinessIncludedBusinessSuccessResponseInfo
     */
    'code': number;
    /**
     * 
     * @type {string}
     * @memberof GetTrashBinAggregateBusinessIncludedBusinessSuccessResponseInfo
     */
    'message': string;
    /**
     * 
     * @type {GetTrashBinAggregateBusinessIncludedBusinessSuccessResponseInfoAllOfResult}
     * @memberof GetTrashBinAggregateBusinessIncludedBusinessSuccessResponseInfo
     */
    'result': GetTrashBinAggregateBusinessIncludedBusinessSuccessResponseInfoAllOfResult;
}
/**
 * 
 * @export
 * @interface GetTrashBinAggregateBusinessIncludedBusinessSuccessResponseInfoAllOfResult
 */
export interface GetTrashBinAggregateBusinessIncludedBusinessSuccessResponseInfoAllOfResult {
    /**
     * 
     * @type {Array<AggregateBusinessIncludedBusiness>}
     * @memberof GetTrashBinAggregateBusinessIncludedBusinessSuccessResponseInfoAllOfResult
     */
    'data'?: Array<AggregateBusinessIncludedBusiness>;
}
/**
 * ゴミ箱内の集計情報取得APIのレスポンスで返ってくるデータの型\"
 * @export
 * @interface GetTrashBinAggregateBusinessSuccessResponseInfo
 */
export interface GetTrashBinAggregateBusinessSuccessResponseInfo {
    /**
     * 
     * @type {number}
     * @memberof GetTrashBinAggregateBusinessSuccessResponseInfo
     */
    'statusCode': number;
    /**
     * 
     * @type {number}
     * @memberof GetTrashBinAggregateBusinessSuccessResponseInfo
     */
    'code': number;
    /**
     * 
     * @type {string}
     * @memberof GetTrashBinAggregateBusinessSuccessResponseInfo
     */
    'message': string;
    /**
     * 
     * @type {GetTrashBinAggregateBusinessSuccessResponseInfoAllOfResult}
     * @memberof GetTrashBinAggregateBusinessSuccessResponseInfo
     */
    'result': GetTrashBinAggregateBusinessSuccessResponseInfoAllOfResult;
}
/**
 * 
 * @export
 * @interface GetTrashBinAggregateBusinessSuccessResponseInfoAllOfResult
 */
export interface GetTrashBinAggregateBusinessSuccessResponseInfoAllOfResult {
    /**
     * 
     * @type {Array<AggregateBusiness>}
     * @memberof GetTrashBinAggregateBusinessSuccessResponseInfoAllOfResult
     */
    'data'?: Array<AggregateBusiness>;
    /**
     * 
     * @type {PagingOptions}
     * @memberof GetTrashBinAggregateBusinessSuccessResponseInfoAllOfResult
     */
    'pagingOptions'?: PagingOptions;
}
/**
 * ゴミ箱内の集計情報全件ID取得APIのレスポンスで返ってくるデータの型
 * @export
 * @interface GetTrashBinAllAggregateBusinessSuccessResponseInfo
 */
export interface GetTrashBinAllAggregateBusinessSuccessResponseInfo {
    /**
     * 
     * @type {number}
     * @memberof GetTrashBinAllAggregateBusinessSuccessResponseInfo
     */
    'statusCode': number;
    /**
     * 
     * @type {number}
     * @memberof GetTrashBinAllAggregateBusinessSuccessResponseInfo
     */
    'code': number;
    /**
     * 
     * @type {string}
     * @memberof GetTrashBinAllAggregateBusinessSuccessResponseInfo
     */
    'message': string;
    /**
     * 
     * @type {GetTrashBinAllAggregateBusinessSuccessResponseInfoAllOfResult}
     * @memberof GetTrashBinAllAggregateBusinessSuccessResponseInfo
     */
    'result': GetTrashBinAllAggregateBusinessSuccessResponseInfoAllOfResult;
}
/**
 * 
 * @export
 * @interface GetTrashBinAllAggregateBusinessSuccessResponseInfoAllOfResult
 */
export interface GetTrashBinAllAggregateBusinessSuccessResponseInfoAllOfResult {
    /**
     * 
     * @type {Array<string>}
     * @memberof GetTrashBinAllAggregateBusinessSuccessResponseInfoAllOfResult
     */
    'data'?: Array<string>;
}
/**
 * ゴミ箱内の取引情報全件ID取得APIのレスポンスで返ってくるデータの型
 * @export
 * @interface GetTrashBinAllBusinessSuccessResponseInfo
 */
export interface GetTrashBinAllBusinessSuccessResponseInfo {
    /**
     * 
     * @type {number}
     * @memberof GetTrashBinAllBusinessSuccessResponseInfo
     */
    'statusCode': number;
    /**
     * 
     * @type {number}
     * @memberof GetTrashBinAllBusinessSuccessResponseInfo
     */
    'code': number;
    /**
     * 
     * @type {string}
     * @memberof GetTrashBinAllBusinessSuccessResponseInfo
     */
    'message': string;
    /**
     * 
     * @type {GetTrashBinAllBusinessSuccessResponseInfoAllOfResult}
     * @memberof GetTrashBinAllBusinessSuccessResponseInfo
     */
    'result': GetTrashBinAllBusinessSuccessResponseInfoAllOfResult;
}
/**
 * 
 * @export
 * @interface GetTrashBinAllBusinessSuccessResponseInfoAllOfResult
 */
export interface GetTrashBinAllBusinessSuccessResponseInfoAllOfResult {
    /**
     * 
     * @type {Array<string>}
     * @memberof GetTrashBinAllBusinessSuccessResponseInfoAllOfResult
     */
    'data'?: Array<string>;
}
/**
 * ゴミ箱内の取引情報取得APIのレスポンスで返ってくるデータの型\"
 * @export
 * @interface GetTrashBinBusinessSuccessResponseInfo
 */
export interface GetTrashBinBusinessSuccessResponseInfo {
    /**
     * 
     * @type {number}
     * @memberof GetTrashBinBusinessSuccessResponseInfo
     */
    'statusCode': number;
    /**
     * 
     * @type {number}
     * @memberof GetTrashBinBusinessSuccessResponseInfo
     */
    'code': number;
    /**
     * 
     * @type {string}
     * @memberof GetTrashBinBusinessSuccessResponseInfo
     */
    'message': string;
    /**
     * 
     * @type {GetTrashBinBusinessSuccessResponseInfoAllOfResult}
     * @memberof GetTrashBinBusinessSuccessResponseInfo
     */
    'result': GetTrashBinBusinessSuccessResponseInfoAllOfResult;
}
/**
 * 
 * @export
 * @interface GetTrashBinBusinessSuccessResponseInfoAllOfResult
 */
export interface GetTrashBinBusinessSuccessResponseInfoAllOfResult {
    /**
     * 
     * @type {Array<Business>}
     * @memberof GetTrashBinBusinessSuccessResponseInfoAllOfResult
     */
    'data'?: Array<Business>;
    /**
     * 
     * @type {PagingOptions}
     * @memberof GetTrashBinBusinessSuccessResponseInfoAllOfResult
     */
    'pagingOptions'?: PagingOptions;
}
/**
 * 在庫情報
 * @export
 * @interface Inventory
 */
export interface Inventory {
    /**
     * 集計ID
     * @type {string}
     * @memberof Inventory
     */
    'aggregateBusinessId'?: string;
    /**
     * 在庫ID
     * @type {string}
     * @memberof Inventory
     */
    'inventoryId'?: string;
    /**
     * 在庫年
     * @type {number}
     * @memberof Inventory
     */
    'targetYear'?: number;
    /**
     * 在庫月
     * @type {number}
     * @memberof Inventory
     */
    'targetMonth'?: number;
    /**
     * 在庫数量
     * @type {number}
     * @memberof Inventory
     */
    'inventoryAmount'?: number;
}
/**
 * APIから受け取るpagingOptionsの情報
 * @export
 * @interface PagingOptions
 */
export interface PagingOptions {
    /**
     * 
     * @type {number}
     * @memberof PagingOptions
     */
    'offset': number;
    /**
     * 
     * @type {number}
     * @memberof PagingOptions
     */
    'nextOffset': number;
    /**
     * 
     * @type {number}
     * @memberof PagingOptions
     */
    'pageSize': number;
    /**
     * 
     * @type {number}
     * @memberof PagingOptions
     */
    'totalResultsAvailable': number;
    /**
     * 
     * @type {number}
     * @memberof PagingOptions
     */
    'returnCount': number;
}
/**
 * 販売実績
 * @export
 * @interface SalesResult
 */
export interface SalesResult {
    /**
     * 集計/関連取引ID
     * @type {string}
     * @memberof SalesResult
     */
    'businessId'?: string;
    /**
     * 販売実績対象年
     * @type {number}
     * @memberof SalesResult
     */
    'targetYear'?: number;
    /**
     * 販売実績対象月
     * @type {number}
     * @memberof SalesResult
     */
    'targetMonth'?: number;
    /**
     * 販売数量
     * @type {number}
     * @memberof SalesResult
     */
    'salesResultAmount'?: number;
}
/**
 * ソート種別
 * @export
 * @enum {string}
 */

export const SortType = {
    Asc: 'ASC',
    Desc: 'DESC'
} as const;

export type SortType = typeof SortType[keyof typeof SortType];


/**
 * 成功レスポンス
 * @export
 * @interface SuccessResponse
 */
export interface SuccessResponse {
    /**
     * 
     * @type {number}
     * @memberof SuccessResponse
     */
    'statusCode': number;
    /**
     * 
     * @type {number}
     * @memberof SuccessResponse
     */
    'code': number;
    /**
     * 
     * @type {string}
     * @memberof SuccessResponse
     */
    'message': string;
    /**
     * 
     * @type {object}
     * @memberof SuccessResponse
     */
    'result': object;
}
/**
 * 
 * @export
 * @interface UpdateTrashBinAggregateBusinessRequest
 */
export interface UpdateTrashBinAggregateBusinessRequest {
    /**
     * 復元する集計情報のID一覧
     * @type {Array<string>}
     * @memberof UpdateTrashBinAggregateBusinessRequest
     */
    'updateTrashBinAggregateBusinessIdArray'?: Array<string>;
    /**
     * isTrashフラグ
     * @type {boolean}
     * @memberof UpdateTrashBinAggregateBusinessRequest
     */
    'isTrashFlag'?: boolean;
}
/**
 * ゴミ箱内集計情報のisTrashフラグ切り替えAPIのレスポンスで返ってくるデータの型\"
 * @export
 * @interface UpdateTrashBinAggregateBusinessSuccessResponseInfo
 */
export interface UpdateTrashBinAggregateBusinessSuccessResponseInfo {
    /**
     * 
     * @type {number}
     * @memberof UpdateTrashBinAggregateBusinessSuccessResponseInfo
     */
    'statusCode': number;
    /**
     * 
     * @type {number}
     * @memberof UpdateTrashBinAggregateBusinessSuccessResponseInfo
     */
    'code': number;
    /**
     * 
     * @type {string}
     * @memberof UpdateTrashBinAggregateBusinessSuccessResponseInfo
     */
    'message': string;
    /**
     * 
     * @type {UpdateTrashBinAggregateBusinessSuccessResponseInfoAllOfResult}
     * @memberof UpdateTrashBinAggregateBusinessSuccessResponseInfo
     */
    'result': UpdateTrashBinAggregateBusinessSuccessResponseInfoAllOfResult;
}
/**
 * 
 * @export
 * @interface UpdateTrashBinAggregateBusinessSuccessResponseInfoAllOfResult
 */
export interface UpdateTrashBinAggregateBusinessSuccessResponseInfoAllOfResult {
    /**
     * idの配列 or Noneを返す
     * @type {Array<string>}
     * @memberof UpdateTrashBinAggregateBusinessSuccessResponseInfoAllOfResult
     */
    'data'?: Array<string>;
}
/**
 * 
 * @export
 * @interface UpdateTrashBinBusinessRequest
 */
export interface UpdateTrashBinBusinessRequest {
    /**
     * 復元する取引情報のID一覧
     * @type {Array<string>}
     * @memberof UpdateTrashBinBusinessRequest
     */
    'updateTrashBinBusinessIdArray'?: Array<string>;
    /**
     * isTrashフラグ
     * @type {boolean}
     * @memberof UpdateTrashBinBusinessRequest
     */
    'isTrashFlag'?: boolean;
}
/**
 * ゴミ箱内取引情報のisTrashフラグ切り替えAPIのレスポンスで返ってくるデータの型\"
 * @export
 * @interface UpdateTrashBinBusinessSuccessResponseInfo
 */
export interface UpdateTrashBinBusinessSuccessResponseInfo {
    /**
     * 
     * @type {number}
     * @memberof UpdateTrashBinBusinessSuccessResponseInfo
     */
    'statusCode': number;
    /**
     * 
     * @type {number}
     * @memberof UpdateTrashBinBusinessSuccessResponseInfo
     */
    'code': number;
    /**
     * 
     * @type {string}
     * @memberof UpdateTrashBinBusinessSuccessResponseInfo
     */
    'message': string;
    /**
     * 
     * @type {UpdateTrashBinAggregateBusinessSuccessResponseInfoAllOfResult}
     * @memberof UpdateTrashBinBusinessSuccessResponseInfo
     */
    'result': UpdateTrashBinAggregateBusinessSuccessResponseInfoAllOfResult;
}
/**
 * リクエストに含めるフィルター項目の型
 * @export
 * @interface UseFilterItem
 */
export interface UseFilterItem {
    /**
     * 置場CD
     * @type {string}
     * @memberof UseFilterItem
     */
    'warehouseNumber'?: string;
    /**
     * 置場名
     * @type {string}
     * @memberof UseFilterItem
     */
    'warehouse'?: string;
    /**
     * 仕入先CD
     * @type {string}
     * @memberof UseFilterItem
     */
    'supplierNumber'?: string;
    /**
     * 仕入先名
     * @type {string}
     * @memberof UseFilterItem
     */
    'supplierName'?: string;
    /**
     * 商品CD
     * @type {string}
     * @memberof UseFilterItem
     */
    'businessNumber'?: string;
    /**
     * 商品名
     * @type {string}
     * @memberof UseFilterItem
     */
    'businessName'?: string;
    /**
     * 容量
     * @type {number}
     * @memberof UseFilterItem
     */
    'package'?: number;
    /**
     * 単位
     * @type {string}
     * @memberof UseFilterItem
     */
    'unit'?: string;
    /**
     * 製造社
     * @type {string}
     * @memberof UseFilterItem
     */
    'manufacturer'?: string;
    /**
     * 集計取引担当者Id
     * @type {string}
     * @memberof UseFilterItem
     */
    'aggregateBusinessResponsibleUserId'?: string;
    /**
     * 売上先CD
     * @type {string}
     * @memberof UseFilterItem
     */
    'customerNumber'?: string;
    /**
     * 売上先名
     * @type {string}
     * @memberof UseFilterItem
     */
    'customerName'?: string;
    /**
     * 送り先CD
     * @type {string}
     * @memberof UseFilterItem
     */
    'salesDestinationNumber'?: string;
    /**
     * 送り先名
     * @type {string}
     * @memberof UseFilterItem
     */
    'salesDestinationName'?: string;
    /**
     * エンドユーザー
     * @type {string}
     * @memberof UseFilterItem
     */
    'endUser'?: string;
    /**
     * 関連取引担当者ID
     * @type {string}
     * @memberof UseFilterItem
     */
    'baseBusinessResponsibleUserId'?: string;
}
/**
 * ユーザーデータ
 * @export
 * @interface UserData
 */
export interface UserData {
    /**
     * 
     * @type {string}
     * @memberof UserData
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserData
     */
    'name'?: string;
}

/**
 * TrashBinApi - axios parameter creator
 * @export
 */
export const TrashBinApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary ゴミ箱内の情報を完全削除する(集計)
         * @param {DeleteTrashBinAggregateBusinessRequest} deleteTrashBinAggregateBusinessRequest 削除する集計情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTrashBinAggregateBusiness: async (deleteTrashBinAggregateBusinessRequest: DeleteTrashBinAggregateBusinessRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deleteTrashBinAggregateBusinessRequest' is not null or undefined
            assertParamExists('deleteTrashBinAggregateBusiness', 'deleteTrashBinAggregateBusinessRequest', deleteTrashBinAggregateBusinessRequest)
            const localVarPath = `/trash-bin/aggregate-business/delete-flag`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(deleteTrashBinAggregateBusinessRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary ゴミ箱内の情報を完全削除する(取引)
         * @param {DeleteTrashBinBusinessRequest} deleteTrashBinBusinessRequest 削除する取引情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTrashBinBusiness: async (deleteTrashBinBusinessRequest: DeleteTrashBinBusinessRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deleteTrashBinBusinessRequest' is not null or undefined
            assertParamExists('deleteTrashBinBusiness', 'deleteTrashBinBusinessRequest', deleteTrashBinBusinessRequest)
            const localVarPath = `/trash-bin/business/delete-flag`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(deleteTrashBinBusinessRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary ゴミ箱内の情報を取得する(集計)
         * @param {SortType} sortType ソートの種類(asc/desc)
         * @param {number} limit 情報の表示最大数
         * @param {number} offset 表示する情報のオフセット
         * @param {CurrentYearMonth} currentYearMonth 現在の年月
         * @param {string} [sortTarget] ソート対象のカラム名
         * @param {UseFilterItem} [filterItem] フィルター対象の項目と情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTrashBinAggregateBusiness: async (sortType: SortType, limit: number, offset: number, currentYearMonth: CurrentYearMonth, sortTarget?: string, filterItem?: UseFilterItem, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sortType' is not null or undefined
            assertParamExists('getTrashBinAggregateBusiness', 'sortType', sortType)
            // verify required parameter 'limit' is not null or undefined
            assertParamExists('getTrashBinAggregateBusiness', 'limit', limit)
            // verify required parameter 'offset' is not null or undefined
            assertParamExists('getTrashBinAggregateBusiness', 'offset', offset)
            // verify required parameter 'currentYearMonth' is not null or undefined
            assertParamExists('getTrashBinAggregateBusiness', 'currentYearMonth', currentYearMonth)
            const localVarPath = `/trash-bin/aggregate-business`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (sortType !== undefined) {
                localVarQueryParameter['sort_type'] = sortType;
            }

            if (sortTarget !== undefined) {
                localVarQueryParameter['sort_target'] = sortTarget;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (currentYearMonth !== undefined) {
                for (const [key, value] of Object.entries(currentYearMonth)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (filterItem !== undefined) {
                for (const [key, value] of Object.entries(filterItem)) {
                    localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary ゴミ箱内の全集計データのIDを取得する(集計)
         * @param {UseFilterItem} [filterItem] フィルター対象の項目と情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTrashBinAggregateBusinessAll: async (filterItem?: UseFilterItem, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/trash-bin/aggregate-business-all`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (filterItem !== undefined) {
                for (const [key, value] of Object.entries(filterItem)) {
                    localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 集計情報を展開した際の情報を取得するAPI
         * @param {SortType} sortType ソートの種類（asc/desc）
         * @param {string} aggregateBusinessId 集計取引ID
         * @param {CurrentYearMonth} currentYearMonth 現在の年月
         * @param {UseFilterItem} [filterItem] フィルター対象の項目と情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTrashBinAggregateBusinessIncludedBusiness: async (sortType: SortType, aggregateBusinessId: string, currentYearMonth: CurrentYearMonth, filterItem?: UseFilterItem, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sortType' is not null or undefined
            assertParamExists('getTrashBinAggregateBusinessIncludedBusiness', 'sortType', sortType)
            // verify required parameter 'aggregateBusinessId' is not null or undefined
            assertParamExists('getTrashBinAggregateBusinessIncludedBusiness', 'aggregateBusinessId', aggregateBusinessId)
            // verify required parameter 'currentYearMonth' is not null or undefined
            assertParamExists('getTrashBinAggregateBusinessIncludedBusiness', 'currentYearMonth', currentYearMonth)
            const localVarPath = `/trash-bin/aggregate-business/included-business`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (sortType !== undefined) {
                localVarQueryParameter['sort_type'] = sortType;
            }

            if (aggregateBusinessId !== undefined) {
                localVarQueryParameter['aggregate_business_id'] = aggregateBusinessId;
            }

            if (currentYearMonth !== undefined) {
                for (const [key, value] of Object.entries(currentYearMonth)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (filterItem !== undefined) {
                for (const [key, value] of Object.entries(filterItem)) {
                    localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary ゴミ箱内の情報を取得する(関連取引)
         * @param {SortType} sortType ソートの種類(asc/desc)
         * @param {number} limit 情報の表示最大数
         * @param {number} offset 表示する情報のオフセット
         * @param {CurrentYearMonth} currentYearMonth 現在の年月
         * @param {string} [sortTarget] ソート対象のカラム名
         * @param {UseFilterItem} [filterItem] フィルター対象の項目と情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTrashBinBusiness: async (sortType: SortType, limit: number, offset: number, currentYearMonth: CurrentYearMonth, sortTarget?: string, filterItem?: UseFilterItem, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sortType' is not null or undefined
            assertParamExists('getTrashBinBusiness', 'sortType', sortType)
            // verify required parameter 'limit' is not null or undefined
            assertParamExists('getTrashBinBusiness', 'limit', limit)
            // verify required parameter 'offset' is not null or undefined
            assertParamExists('getTrashBinBusiness', 'offset', offset)
            // verify required parameter 'currentYearMonth' is not null or undefined
            assertParamExists('getTrashBinBusiness', 'currentYearMonth', currentYearMonth)
            const localVarPath = `/trash-bin/business`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (sortType !== undefined) {
                localVarQueryParameter['sort_type'] = sortType;
            }

            if (sortTarget !== undefined) {
                localVarQueryParameter['sort_target'] = sortTarget;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (currentYearMonth !== undefined) {
                for (const [key, value] of Object.entries(currentYearMonth)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (filterItem !== undefined) {
                for (const [key, value] of Object.entries(filterItem)) {
                    localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary ゴミ箱内の全集計データのIDを取得する(取引)
         * @param {UseFilterItem} [filterItem] フィルター対象の項目と情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTrashBinBusinessAll: async (filterItem?: UseFilterItem, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/trash-bin/business-all`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (filterItem !== undefined) {
                for (const [key, value] of Object.entries(filterItem)) {
                    localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary ゴミ箱内の情報のisTrashフラグを切り替える(集計)
         * @param {UpdateTrashBinAggregateBusinessRequest} updateTrashBinAggregateBusinessRequest 復元する情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTrashBinAggregateBusiness: async (updateTrashBinAggregateBusinessRequest: UpdateTrashBinAggregateBusinessRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'updateTrashBinAggregateBusinessRequest' is not null or undefined
            assertParamExists('updateTrashBinAggregateBusiness', 'updateTrashBinAggregateBusinessRequest', updateTrashBinAggregateBusinessRequest)
            const localVarPath = `/trash-bin/aggregate-business/trash-flag`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateTrashBinAggregateBusinessRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary ゴミ箱内の情報のisTrashフラグを切り替える(取引)
         * @param {UpdateTrashBinBusinessRequest} updateTrashBinBusinessRequest 復元する情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTrashBinBusiness: async (updateTrashBinBusinessRequest: UpdateTrashBinBusinessRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'updateTrashBinBusinessRequest' is not null or undefined
            assertParamExists('updateTrashBinBusiness', 'updateTrashBinBusinessRequest', updateTrashBinBusinessRequest)
            const localVarPath = `/trash-bin/business/trash-flag`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateTrashBinBusinessRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TrashBinApi - functional programming interface
 * @export
 */
export const TrashBinApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TrashBinApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary ゴミ箱内の情報を完全削除する(集計)
         * @param {DeleteTrashBinAggregateBusinessRequest} deleteTrashBinAggregateBusinessRequest 削除する集計情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteTrashBinAggregateBusiness(deleteTrashBinAggregateBusinessRequest: DeleteTrashBinAggregateBusinessRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeleteTrashBinAggregateBusinessSuccessResponseInfo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteTrashBinAggregateBusiness(deleteTrashBinAggregateBusinessRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TrashBinApi.deleteTrashBinAggregateBusiness']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary ゴミ箱内の情報を完全削除する(取引)
         * @param {DeleteTrashBinBusinessRequest} deleteTrashBinBusinessRequest 削除する取引情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteTrashBinBusiness(deleteTrashBinBusinessRequest: DeleteTrashBinBusinessRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeleteTrashBinBusinessSuccessResponseInfo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteTrashBinBusiness(deleteTrashBinBusinessRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TrashBinApi.deleteTrashBinBusiness']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary ゴミ箱内の情報を取得する(集計)
         * @param {SortType} sortType ソートの種類(asc/desc)
         * @param {number} limit 情報の表示最大数
         * @param {number} offset 表示する情報のオフセット
         * @param {CurrentYearMonth} currentYearMonth 現在の年月
         * @param {string} [sortTarget] ソート対象のカラム名
         * @param {UseFilterItem} [filterItem] フィルター対象の項目と情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTrashBinAggregateBusiness(sortType: SortType, limit: number, offset: number, currentYearMonth: CurrentYearMonth, sortTarget?: string, filterItem?: UseFilterItem, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetTrashBinAggregateBusinessSuccessResponseInfo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTrashBinAggregateBusiness(sortType, limit, offset, currentYearMonth, sortTarget, filterItem, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TrashBinApi.getTrashBinAggregateBusiness']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary ゴミ箱内の全集計データのIDを取得する(集計)
         * @param {UseFilterItem} [filterItem] フィルター対象の項目と情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTrashBinAggregateBusinessAll(filterItem?: UseFilterItem, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetTrashBinAllAggregateBusinessSuccessResponseInfo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTrashBinAggregateBusinessAll(filterItem, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TrashBinApi.getTrashBinAggregateBusinessAll']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 集計情報を展開した際の情報を取得するAPI
         * @param {SortType} sortType ソートの種類（asc/desc）
         * @param {string} aggregateBusinessId 集計取引ID
         * @param {CurrentYearMonth} currentYearMonth 現在の年月
         * @param {UseFilterItem} [filterItem] フィルター対象の項目と情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTrashBinAggregateBusinessIncludedBusiness(sortType: SortType, aggregateBusinessId: string, currentYearMonth: CurrentYearMonth, filterItem?: UseFilterItem, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetTrashBinAggregateBusinessIncludedBusinessSuccessResponseInfo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTrashBinAggregateBusinessIncludedBusiness(sortType, aggregateBusinessId, currentYearMonth, filterItem, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TrashBinApi.getTrashBinAggregateBusinessIncludedBusiness']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary ゴミ箱内の情報を取得する(関連取引)
         * @param {SortType} sortType ソートの種類(asc/desc)
         * @param {number} limit 情報の表示最大数
         * @param {number} offset 表示する情報のオフセット
         * @param {CurrentYearMonth} currentYearMonth 現在の年月
         * @param {string} [sortTarget] ソート対象のカラム名
         * @param {UseFilterItem} [filterItem] フィルター対象の項目と情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTrashBinBusiness(sortType: SortType, limit: number, offset: number, currentYearMonth: CurrentYearMonth, sortTarget?: string, filterItem?: UseFilterItem, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetTrashBinBusinessSuccessResponseInfo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTrashBinBusiness(sortType, limit, offset, currentYearMonth, sortTarget, filterItem, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TrashBinApi.getTrashBinBusiness']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary ゴミ箱内の全集計データのIDを取得する(取引)
         * @param {UseFilterItem} [filterItem] フィルター対象の項目と情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTrashBinBusinessAll(filterItem?: UseFilterItem, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetTrashBinAllBusinessSuccessResponseInfo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTrashBinBusinessAll(filterItem, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TrashBinApi.getTrashBinBusinessAll']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary ゴミ箱内の情報のisTrashフラグを切り替える(集計)
         * @param {UpdateTrashBinAggregateBusinessRequest} updateTrashBinAggregateBusinessRequest 復元する情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateTrashBinAggregateBusiness(updateTrashBinAggregateBusinessRequest: UpdateTrashBinAggregateBusinessRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateTrashBinAggregateBusinessSuccessResponseInfo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateTrashBinAggregateBusiness(updateTrashBinAggregateBusinessRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TrashBinApi.updateTrashBinAggregateBusiness']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary ゴミ箱内の情報のisTrashフラグを切り替える(取引)
         * @param {UpdateTrashBinBusinessRequest} updateTrashBinBusinessRequest 復元する情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateTrashBinBusiness(updateTrashBinBusinessRequest: UpdateTrashBinBusinessRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateTrashBinBusinessSuccessResponseInfo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateTrashBinBusiness(updateTrashBinBusinessRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TrashBinApi.updateTrashBinBusiness']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TrashBinApi - factory interface
 * @export
 */
export const TrashBinApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TrashBinApiFp(configuration)
    return {
        /**
         * 
         * @summary ゴミ箱内の情報を完全削除する(集計)
         * @param {DeleteTrashBinAggregateBusinessRequest} deleteTrashBinAggregateBusinessRequest 削除する集計情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTrashBinAggregateBusiness(deleteTrashBinAggregateBusinessRequest: DeleteTrashBinAggregateBusinessRequest, options?: any): AxiosPromise<DeleteTrashBinAggregateBusinessSuccessResponseInfo> {
            return localVarFp.deleteTrashBinAggregateBusiness(deleteTrashBinAggregateBusinessRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary ゴミ箱内の情報を完全削除する(取引)
         * @param {DeleteTrashBinBusinessRequest} deleteTrashBinBusinessRequest 削除する取引情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTrashBinBusiness(deleteTrashBinBusinessRequest: DeleteTrashBinBusinessRequest, options?: any): AxiosPromise<DeleteTrashBinBusinessSuccessResponseInfo> {
            return localVarFp.deleteTrashBinBusiness(deleteTrashBinBusinessRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary ゴミ箱内の情報を取得する(集計)
         * @param {SortType} sortType ソートの種類(asc/desc)
         * @param {number} limit 情報の表示最大数
         * @param {number} offset 表示する情報のオフセット
         * @param {CurrentYearMonth} currentYearMonth 現在の年月
         * @param {string} [sortTarget] ソート対象のカラム名
         * @param {UseFilterItem} [filterItem] フィルター対象の項目と情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTrashBinAggregateBusiness(sortType: SortType, limit: number, offset: number, currentYearMonth: CurrentYearMonth, sortTarget?: string, filterItem?: UseFilterItem, options?: any): AxiosPromise<GetTrashBinAggregateBusinessSuccessResponseInfo> {
            return localVarFp.getTrashBinAggregateBusiness(sortType, limit, offset, currentYearMonth, sortTarget, filterItem, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary ゴミ箱内の全集計データのIDを取得する(集計)
         * @param {UseFilterItem} [filterItem] フィルター対象の項目と情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTrashBinAggregateBusinessAll(filterItem?: UseFilterItem, options?: any): AxiosPromise<GetTrashBinAllAggregateBusinessSuccessResponseInfo> {
            return localVarFp.getTrashBinAggregateBusinessAll(filterItem, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 集計情報を展開した際の情報を取得するAPI
         * @param {SortType} sortType ソートの種類（asc/desc）
         * @param {string} aggregateBusinessId 集計取引ID
         * @param {CurrentYearMonth} currentYearMonth 現在の年月
         * @param {UseFilterItem} [filterItem] フィルター対象の項目と情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTrashBinAggregateBusinessIncludedBusiness(sortType: SortType, aggregateBusinessId: string, currentYearMonth: CurrentYearMonth, filterItem?: UseFilterItem, options?: any): AxiosPromise<GetTrashBinAggregateBusinessIncludedBusinessSuccessResponseInfo> {
            return localVarFp.getTrashBinAggregateBusinessIncludedBusiness(sortType, aggregateBusinessId, currentYearMonth, filterItem, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary ゴミ箱内の情報を取得する(関連取引)
         * @param {SortType} sortType ソートの種類(asc/desc)
         * @param {number} limit 情報の表示最大数
         * @param {number} offset 表示する情報のオフセット
         * @param {CurrentYearMonth} currentYearMonth 現在の年月
         * @param {string} [sortTarget] ソート対象のカラム名
         * @param {UseFilterItem} [filterItem] フィルター対象の項目と情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTrashBinBusiness(sortType: SortType, limit: number, offset: number, currentYearMonth: CurrentYearMonth, sortTarget?: string, filterItem?: UseFilterItem, options?: any): AxiosPromise<GetTrashBinBusinessSuccessResponseInfo> {
            return localVarFp.getTrashBinBusiness(sortType, limit, offset, currentYearMonth, sortTarget, filterItem, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary ゴミ箱内の全集計データのIDを取得する(取引)
         * @param {UseFilterItem} [filterItem] フィルター対象の項目と情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTrashBinBusinessAll(filterItem?: UseFilterItem, options?: any): AxiosPromise<GetTrashBinAllBusinessSuccessResponseInfo> {
            return localVarFp.getTrashBinBusinessAll(filterItem, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary ゴミ箱内の情報のisTrashフラグを切り替える(集計)
         * @param {UpdateTrashBinAggregateBusinessRequest} updateTrashBinAggregateBusinessRequest 復元する情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTrashBinAggregateBusiness(updateTrashBinAggregateBusinessRequest: UpdateTrashBinAggregateBusinessRequest, options?: any): AxiosPromise<UpdateTrashBinAggregateBusinessSuccessResponseInfo> {
            return localVarFp.updateTrashBinAggregateBusiness(updateTrashBinAggregateBusinessRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary ゴミ箱内の情報のisTrashフラグを切り替える(取引)
         * @param {UpdateTrashBinBusinessRequest} updateTrashBinBusinessRequest 復元する情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTrashBinBusiness(updateTrashBinBusinessRequest: UpdateTrashBinBusinessRequest, options?: any): AxiosPromise<UpdateTrashBinBusinessSuccessResponseInfo> {
            return localVarFp.updateTrashBinBusiness(updateTrashBinBusinessRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TrashBinApi - object-oriented interface
 * @export
 * @class TrashBinApi
 * @extends {BaseAPI}
 */
export class TrashBinApi extends BaseAPI {
    /**
     * 
     * @summary ゴミ箱内の情報を完全削除する(集計)
     * @param {DeleteTrashBinAggregateBusinessRequest} deleteTrashBinAggregateBusinessRequest 削除する集計情報
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrashBinApi
     */
    public deleteTrashBinAggregateBusiness(deleteTrashBinAggregateBusinessRequest: DeleteTrashBinAggregateBusinessRequest, options?: RawAxiosRequestConfig) {
        return TrashBinApiFp(this.configuration).deleteTrashBinAggregateBusiness(deleteTrashBinAggregateBusinessRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary ゴミ箱内の情報を完全削除する(取引)
     * @param {DeleteTrashBinBusinessRequest} deleteTrashBinBusinessRequest 削除する取引情報
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrashBinApi
     */
    public deleteTrashBinBusiness(deleteTrashBinBusinessRequest: DeleteTrashBinBusinessRequest, options?: RawAxiosRequestConfig) {
        return TrashBinApiFp(this.configuration).deleteTrashBinBusiness(deleteTrashBinBusinessRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary ゴミ箱内の情報を取得する(集計)
     * @param {SortType} sortType ソートの種類(asc/desc)
     * @param {number} limit 情報の表示最大数
     * @param {number} offset 表示する情報のオフセット
     * @param {CurrentYearMonth} currentYearMonth 現在の年月
     * @param {string} [sortTarget] ソート対象のカラム名
     * @param {UseFilterItem} [filterItem] フィルター対象の項目と情報
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrashBinApi
     */
    public getTrashBinAggregateBusiness(sortType: SortType, limit: number, offset: number, currentYearMonth: CurrentYearMonth, sortTarget?: string, filterItem?: UseFilterItem, options?: RawAxiosRequestConfig) {
        return TrashBinApiFp(this.configuration).getTrashBinAggregateBusiness(sortType, limit, offset, currentYearMonth, sortTarget, filterItem, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary ゴミ箱内の全集計データのIDを取得する(集計)
     * @param {UseFilterItem} [filterItem] フィルター対象の項目と情報
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrashBinApi
     */
    public getTrashBinAggregateBusinessAll(filterItem?: UseFilterItem, options?: RawAxiosRequestConfig) {
        return TrashBinApiFp(this.configuration).getTrashBinAggregateBusinessAll(filterItem, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 集計情報を展開した際の情報を取得するAPI
     * @param {SortType} sortType ソートの種類（asc/desc）
     * @param {string} aggregateBusinessId 集計取引ID
     * @param {CurrentYearMonth} currentYearMonth 現在の年月
     * @param {UseFilterItem} [filterItem] フィルター対象の項目と情報
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrashBinApi
     */
    public getTrashBinAggregateBusinessIncludedBusiness(sortType: SortType, aggregateBusinessId: string, currentYearMonth: CurrentYearMonth, filterItem?: UseFilterItem, options?: RawAxiosRequestConfig) {
        return TrashBinApiFp(this.configuration).getTrashBinAggregateBusinessIncludedBusiness(sortType, aggregateBusinessId, currentYearMonth, filterItem, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary ゴミ箱内の情報を取得する(関連取引)
     * @param {SortType} sortType ソートの種類(asc/desc)
     * @param {number} limit 情報の表示最大数
     * @param {number} offset 表示する情報のオフセット
     * @param {CurrentYearMonth} currentYearMonth 現在の年月
     * @param {string} [sortTarget] ソート対象のカラム名
     * @param {UseFilterItem} [filterItem] フィルター対象の項目と情報
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrashBinApi
     */
    public getTrashBinBusiness(sortType: SortType, limit: number, offset: number, currentYearMonth: CurrentYearMonth, sortTarget?: string, filterItem?: UseFilterItem, options?: RawAxiosRequestConfig) {
        return TrashBinApiFp(this.configuration).getTrashBinBusiness(sortType, limit, offset, currentYearMonth, sortTarget, filterItem, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary ゴミ箱内の全集計データのIDを取得する(取引)
     * @param {UseFilterItem} [filterItem] フィルター対象の項目と情報
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrashBinApi
     */
    public getTrashBinBusinessAll(filterItem?: UseFilterItem, options?: RawAxiosRequestConfig) {
        return TrashBinApiFp(this.configuration).getTrashBinBusinessAll(filterItem, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary ゴミ箱内の情報のisTrashフラグを切り替える(集計)
     * @param {UpdateTrashBinAggregateBusinessRequest} updateTrashBinAggregateBusinessRequest 復元する情報
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrashBinApi
     */
    public updateTrashBinAggregateBusiness(updateTrashBinAggregateBusinessRequest: UpdateTrashBinAggregateBusinessRequest, options?: RawAxiosRequestConfig) {
        return TrashBinApiFp(this.configuration).updateTrashBinAggregateBusiness(updateTrashBinAggregateBusinessRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary ゴミ箱内の情報のisTrashフラグを切り替える(取引)
     * @param {UpdateTrashBinBusinessRequest} updateTrashBinBusinessRequest 復元する情報
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrashBinApi
     */
    public updateTrashBinBusiness(updateTrashBinBusinessRequest: UpdateTrashBinBusinessRequest, options?: RawAxiosRequestConfig) {
        return TrashBinApiFp(this.configuration).updateTrashBinBusiness(updateTrashBinBusinessRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



